import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
} from "@mui/material";

const ConfirmDelete = ({confirmDelete, handleDelete, close}) => {
  return (
    <Dialog open={confirmDelete}>
      <DialogTitle id="alert-dialog-title">Please confirm</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Are you sure you want to delete this question?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>cancel</Button>
        <Button autoFocus onClick={handleDelete}>
          delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDelete;
